import Vue from 'vue'
import VueHead from 'vue-head'
import 'fullpage.js/vendors/scrolloverflow'
import 'fullpage.js/dist/fullpage.css'
import VueFullPage from 'vue-fullpage.js'
import typograf from 'typograf'

import App from './App.vue'
import router from './router'
import store from './store'

Vue.use(VueHead)
Vue.use(VueFullPage)
Vue.config.productionTip = false
Vue.prototype.$mobile = window.innerWidth < 1000

let Typograf = new typograf({locale: ['ru', 'en-US']})

Vue.filter('typograf', function (value) {
	return Typograf.execute(value)
})

new Vue({
	router,
	store,
	render: h => h(App),
  mounted: () => document.dispatchEvent(new Event("x-app-rendered")),
}).$mount('#app')